import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Toaster } from "@/components/ui/sonner";

import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import CEOProfile from "@/pages/CEOProfile";
import FounderProfile from "@/pages/FounderProfile";
import FAQ from "@/pages/FAQ";
import TermsConditions from "@/pages/TermsConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TrustCenter from "@/pages/TrustCenter";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import AppMarketplace from "@/pages/AppMarketplace";
import CustomerPortal from "@/pages/CustomerPortal";
import Track from "@/pages/Track";
import Contact from "@/pages/Contact";

import AdminLogin from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/Layout";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminProducts from "@/pages/admin/Products";
import AdminOrders from "@/pages/admin/Orders";
import AdminCategories from "@/pages/admin/Categories";
import AdminInquiries from "@/pages/admin/Inquiries";
import AdminTracking from "@/pages/admin/Tracking";
import AdminClientPortal from "@/pages/admin/ClientPortal";
import AdminCertificates from "@/pages/admin/Certificates";
import AdminTaxTools from "@/pages/admin/TaxTools";
import AdminAnalytics from "@/pages/admin/Analytics";
import AdminAppNotifications from "@/pages/admin/AppNotifications";
import AdminSettings from "@/pages/admin/Settings";

import ProtectedRoute from "@/components/ProtectedRoute";
import { ADMIN_LOGIN_PATH, LEGACY_ADMIN_LOGIN_PATH } from "@/lib/constants";
import { PUBLIC_URL } from "@/lib/env";
import "@/App.css";

function App() {
  const basename = PUBLIC_URL;

  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter basename={basename}>
          <Routes>
            {/* Public routes */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/ceo-profile" element={<CEOProfile />} />
              <Route path="/founder-profile" element={<FounderProfile />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/terms-and-conditions" element={<TermsConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/trust-center" element={<TrustCenter />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/app" element={<AppMarketplace />} />
              <Route path="/client-portal" element={<CustomerPortal />} />
              <Route path="/track" element={<Track />} />
              <Route path="/contact" element={<Contact />} />
            </Route>

            {/* Admin routes */}
            <Route path={ADMIN_LOGIN_PATH} element={<AdminLogin />} />
            <Route path={LEGACY_ADMIN_LOGIN_PATH} element={<Navigate to={ADMIN_LOGIN_PATH} replace />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="tracking" element={<AdminTracking />} />
              <Route path="client-portal" element={<AdminClientPortal />} />
              <Route path="certificates" element={<AdminCertificates />} />
              <Route path="tax-tools" element={<AdminTaxTools />} />
              <Route path="analytics" element={<AdminAnalytics />} />
              <Route path="app-notifications" element={<AdminAppNotifications />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
